import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { DefaultRequestParamsConstant } from '@app/core/_constant/index.constants';
import { LocationService } from '@app/core/locations/services/location.service';

@Component({
  selector: 'filter-warehouse-location',
  templateUrl: './filter-warehouse-location.component.html',
  styleUrls: ['./filter-warehouse-location.component.scss'],
})
export class FilterWarehouseLocationComponent implements OnInit {
  public loading :boolean = true;
  public locationLoading :boolean = true;
  public warehouseList :any[] = [];
  public warehouses :any[] = [];
  public locationList :any[] = [];
  public locations :any[] = [];
  public locationsRaw :any[] = [];
  locationSubscription :Subscription;

  @Input() value :any[];
  @Input() query :string[];
  @Output() warehouseLocationChange :EventEmitter<number[][]> = new EventEmitter<
    number[][]
  >();

  constructor(
    private locationSvc :LocationService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.locationSvc.getAll({ all: 1, parent_id: 0 }).subscribe((resp) => {
      const containsEmptyArray = this.value.some((data) => data.length === 0);
      const containsEmptyString = this.value.some((data) => data === '');
      if (this.value?.length > 0 && (!containsEmptyString || !containsEmptyArray)) {
        this.filterWarehouseFilter();
        this.filterLocationFilter();
      }

      this.warehouseList = resp;
      this.onWarehouseChange();
      this.loading = false;
      this.cd.detectChanges();
    });
  }

  private filterWarehouseFilter() :void {
    this.warehouses = this.value[0].filter((warehouse) => warehouse);
    this.warehouses = this.warehouses.map((warehouse) =>
      typeof warehouse === 'object' ? warehouse.id : warehouse,
    );
  }

  private filterLocationFilter() :void {
    this.locations = this.value[1].filter((location) => location);
    this.locations = this.locations.map((location) =>
      typeof location === 'object' ? location.id : location,
    );
  }

  ngOnDestroy() :void {
    this.locationSubscription?.unsubscribe();
  }

  onLocationChange() {
    this.update();
  }

  onWarehouseChange() {
    this.update();
    if (!this.warehouseList.length) {
      this.locationList = [];
    } else {
      if (this.warehouseList.length === 1 && this.warehouses.length <= 0) {
        this.warehouses = this.warehouseList.map((warehouse) => warehouse.id);
      }

      this.locationSubscription = this.locationSvc
        .getAll({
          all: 1,
          location_only: 1,
          withoutStockLocations: true,
          ids: this.warehouses.join(','),
        })
        .subscribe((resp) => {
          this.locationList = resp;
          this.locationLoading = false;
          this.cd.detectChanges();
        });
    }
  }
  update() {
    this.warehouseLocationChange.emit([this.warehouses, this.locations]);
  }
}
